module.exports = __webpack_public_path__ + "static/img/media_plat.88ca1c57.png";